import { initContract } from '@ts-rest/core';
import { z } from 'zod';

export const GetSettingsSchema = z.object({});

export const PublicSettingsResultSchema = z.object({
  isForwarder: z.boolean(),
  country: z.string(),
  isAdmin: z.boolean(),
  loggingProxyUrl: z.string().url().optional(),
});

export const SettingsResultSchema = z.object({
  clientBaseUrl: z.string().optional(),
  walletEnabled: z.boolean(),
  highValuesIDMSEnabled: z.boolean(),
  aesEnabled: z.boolean(),
  reSendDelay: z.number(),
  transitEnabled: z.boolean(),
  temporaryStorageEnabled: z.boolean(),
  country: z.string(),
  isForwarder: z.boolean(),
  requestTime: z.string(),
  notificationsUrl: z.string(),
  enableUtbReport: z.boolean(),
  isCatalogsTestEnv: z.boolean(),
  isObf: z.boolean(),
  lvInvoiceTreshold: z.number(),
});

const c = initContract();

export const settingsContract = c.router({
  getPublicSettings: {
    method: 'GET',
    path: '/settings/public',
    responses: { 200: z.object({ data: PublicSettingsResultSchema }) },
  },
  getSettings: {
    method: 'GET',
    path: '/settings',
    responses: { 200: z.object({ data: SettingsResultSchema }) },
  },
});
